module.exports = __webpack_public_path__ + "img/traffic-junction-2.84d36e03.jpg";